<template>
  <v-container>
    <v-row>
      <v-col sm="12" md="8">
        <v-row>
          <v-col sm="12">
            <h2 class="text-h2">
              Objednávka odeslána
            </h2>
          </v-col>
        </v-row>

        <template v-if="loading">
          <v-row>
            <v-col sm="12">
              <v-skeleton-loader
                class="mx-auto"
                type="card"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </template>

        <template v-if="!loading">
          <v-row v-if="orderr == null">
            <v-col sm="12">
              <v-alert
                border="bottom"
                colored-border
                type="warning"
                elevation="2"
                class="my-5"
              >
                Nenašli jsme žádnou objednávku podle zadaného čísla objednávky.
              </v-alert>
            </v-col>
          </v-row>

          <template v-if="orderr != null">
            <!-- hlavni obsah -->
            <v-row>
              <v-col sm="12">
                <v-alert
                  border="bottom"
                  colored-border
                  type="success"
                  elevation="2"
                  class="my-5"
                >
                  Děkujeme za vaší objednávku. Na váš e-mail jsme odeslali
                  potvrzení s&nbsp;rekapitulací.
                  <p>
                    V našem systému objednávku evidujeme pod číslem:
                    {{ orderr.orderrNumber }}
                  </p>
                </v-alert>
                <payment-summary
                  v-if="payment"
                  :payment="payment"
                ></payment-summary>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12">
                <v-list
                  v-if="orderr.orderrItemGroups.items.length > 0"
                  three-line
                >
                  <template v-if="orderrItemGroupsRent.length > 0">
                    <v-subheader>{{ mobConfig.rentHeader }}</v-subheader>
                    <v-divider></v-divider>

                    <cart-item-rent
                      v-for="oig in this.orderrItemGroupsRent"
                      v-bind:key="oig.id"
                      v-bind:orderr-item-group="oig"
                    >
                    </cart-item-rent>
                  </template>

                  <v-divider></v-divider>

                  <template v-if="orderrItemGroupsCourse.length > 0">
                    <v-subheader>{{ mobConfig.schoolHeader }}</v-subheader>
                    <v-divider></v-divider>

                    <cart-item-course
                      v-for="oig in this.orderrItemGroupsCourse"
                      v-bind:key="oig.id"
                      v-bind:orderr-item-group="oig"
                    >
                    </cart-item-course>
                  </template>
                </v-list>
              </v-col>
            </v-row>

            <v-row>
              <v-col sm="12" md="8">
                <v-btn @click="goToRent" color="primary">
                  Vytvořit novou rezervaci
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </template>
      </v-col>

      <v-col sm="12" md="4">
        <v-card v-if="!loading && orderr != null">
          <v-card-title>
            Přehled objednávky
          </v-card-title>

          <v-card-text>
            <orderr-summary
              v-bind:orderr="orderr"
              showCreatedAt
              showStatus
              showPaymentMethod
              showDatePickUp
              showPointSell
              showRentalPeriod
              showPrice
            ></orderr-summary>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import APIAdapter from "../store/APIAdapter";
import OrderrSummary from "@/components/OrderrSummary";
import CartItemRent from "@/components/CartItemRent";
import CartItemCourse from "@/components/CartItemCourse";
import PaymentSummary from "@/components/PaymentSummary";

export default {
  metaInfo: {
    title: "Objednávka odeslána"
  },

  components: {
    OrderrSummary,
    CartItemRent,
    CartItemCourse,
    PaymentSummary
  },

  async mounted() {
    console.log("mounted -- checkout-contacts");
    // nastavit stav, ze se nacita
    this.loading = true;

    // zkontrolovat, ze je uzivatel prihlaseny a dalsi nutne prerekvizity
    if (
      this.$store.state.user == null ||
      this.$store.state.appInstance == null
    ) {
      console.log("Nesplnene prerekvizity user nebo app instance jsou null");
      this.$router.push({ name: "rent" });
    }

    if (this.orderrId != null) {
      this.orderr = await APIAdapter.getOrderr(this.orderrId);

      console.log("ORDERR:");
      console.log(this.orderr);
    }

    // nacist aktualni objednavku s polozkami
    await this.$store.dispatch("loadCurrentOrderrCHECKOUT");

    // dokoncit nacitani - zmena stavu
    this.loading = false;
  },

  data: () => ({
    loading: false,
    submiting: false,
    orderr: null
  }),

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },
    orderrId() {
      return this.$route.params.orderrId;
    },
    payment() {
      if (this.orderr == null || this.$route.params.transId == undefined) {
        return null;
      } else {
        for (let i = 0; i < this.orderr.payments.items.length; i++) {
          let payment = this.orderr.payments.items[i];
          if (payment.transId == this.$route.params.transId) {
            return payment;
          }
        }
        return null;
      }
    },
    orderrItemGroupsRent() {
      return this.orderr.orderrItemGroups.items.filter(item => {
        console.log(item);
        return item.product.productType == "RENTAL";
      });
    },

    orderrItemGroupsCourse() {
      return this.orderr.orderrItemGroups.items.filter(
        item => item.product.productType == "SCHOOL"
      );
    }
  },

  methods: {
    goToRent() {
      this.$router.push({ name: "rent" });
    }
  }
};
</script>
